<div id="loadr" class="loaderWrapper hide" *ngIf="isloaderShow">
  <div class="loaderBox">
    <img src="https://images.ctfassets.net/nwnmkeyu03hy/6P1ESpN0LTXFC4ZydQubtU/716077209b622822b82566854a9f917a/balogo-thin.png" class="loaderLogo" /><br />
    <i class="fas fa-times closeForLoader" (click)="closeForLoader()"></i>
    <span style="font-size: 15px">Working on it ...</span>

    <br />
    <div class="nldx2">
      <div class="nldr"></div>
    </div>

    <br />
  </div>
</div>
